import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import AdAddress from '../adAddress';
import ShortDescription from '../shortDescription';

const ContentMap = ({ longitude, latitude, postNumber, postArea, streetAddress, mobile, directionDescription }) => {
    const [displayOverlay, setdisplayOverlay] = useState(mobile);

    return (
        <div className="py-32">
            <h3 className="font-bold mb-16 mt-16" id="beliggenhet">
                Beliggenhet
            </h3>
            <div className="mb-16">
                <AdAddress postNumber={postNumber} postArea={postArea} streetAddress={streetAddress} />
            </div>
            {directionDescription && <ShortDescription text={directionDescription} title="Adkomst" />}
            {latitude && longitude && (
                <S.Map data-testid="s-map">
                    <S.Overlay displayOverlay={displayOverlay}>
                        <button className="button mt-16" onClick={() => setdisplayOverlay(false)} type="button">
                            Klikk for å aktivere kartet
                        </button>
                    </S.Overlay>
                    <iframe
                        allowFullScreen
                        frameBorder="0"
                        src={`https://kart.finn.no/ext/nybygg?lat=${latitude}&lng=${longitude}&zoom=16`}
                        title="Kart med beliggenhet"
                    />
                </S.Map>
            )}
        </div>
    );
};

ContentMap.propTypes = {
    mobile: PropTypes.bool,
    longitude: PropTypes.number,
    latitude: PropTypes.number,
    postNumber: PropTypes.string,
    postArea: PropTypes.string,
    streetAddress: PropTypes.string,
    directionDescription: PropTypes.string,
};

export default ContentMap;
